import { render, staticRenderFns } from "./NicknameBlackKeyword.vue?vue&type=template&id=28e7ba43&scoped=true&"
import script from "./NicknameBlackKeyword.vue?vue&type=script&lang=js&"
export * from "./NicknameBlackKeyword.vue?vue&type=script&lang=js&"
import style0 from "./NicknameBlackKeyword.vue?vue&type=style&index=0&id=28e7ba43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e7ba43",
  null
  
)

export default component.exports